import { CreatorOptions } from '@/types/creator';
import { UUID } from '@/types/types';

export enum UserDataProp {
	OBJECT_TYPE = 'object_type',
	REVERT_SCALE = 'revert_scale',
}

export enum UserDataObjectType {}

export enum ObjectName {
	GRATE_START = 'grate_start',
	GRATE_END = 'grate_end',
	GUTTER_START = 'gutter_start',
	GUTTER_END = 'gutter_end',
	GUTTER = 'gutter',
	SIPHON = 'siphon',
	GRATE = 'grate',
}

export enum ThreeEvent {
	UPDATE_CAMERA_DISTANCE = 'update_camera_distance',
	SET_OPTIONS = 'set_options',
	SET_LENGTH = 'set_length',
	SET_SIPHON_POS_X = 'set_siphon_pos_x',
}

export type ThreeEvents = {
	[ThreeEvent.UPDATE_CAMERA_DISTANCE]: number;
	[ThreeEvent.SET_OPTIONS]: Partial<CreatorOptions>;
	[ThreeEvent.SET_LENGTH]: number;
	[ThreeEvent.SET_SIPHON_POS_X]: { id: UUID; posX: number };
};

export type SerializedRenderer = {};
